import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import { makeGetRequest, makePutRequest } from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'

import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import { refreshNotifications, refreshUserProfile } from 'utils/helpers'
import { setToken } from 'utils/authService'
import { toUserFormData } from './serializers'

function* getUser(action) {
  const { id } = action.payload
  try {
    const url = `/v1/users/${id}`
    const profile = yield makeGetRequest(url)

    yield put({
      type: ACT.GET_USER_FETCH_SUCCESS,
      payload: {
        profile
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue to get user',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* saveUser(action) {
  const { userId, userBody } = action.payload
  try {
    const url = `/v1/users/${userId}`
    const { user, token } = yield makePutRequest(url, userBody)
    setToken(token)

    yield put({
      type: ACT.SAVE_USER_FETCH_SUCCESS,
      payload: {
        profile: user
      }
    })
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'User Profile updated successfully',
        level: 'success'
      }
    })
    yield refreshNotifications(put)
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue to save user',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* updateUserImage(action) {
  const { fileInfo } = action.payload
  try {
    const url = '/v1/users/photo'
    const user = yield makePutRequest(url, toUserFormData(fileInfo))

    yield put({
      type: ACT.UPDATE_USER_IMAGE_FETCH_SUCCESS,
      payload: {
        profile: user
      }
    })
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'User Profile Picture updated successfully',
        level: 'success'
      }
    })
    yield refreshUserProfile(put)
    yield refreshNotifications(put)
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue to save User Profile Picture',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* changePassword(action) {
  const { userBody } = action.payload
  try {
    const url = '/v1/users/changePassword'
    yield makePutRequest(url, {
      oldPassword: userBody.currentPassword,
      newPassword: userBody.newPassword
    })

    yield put({
      type: ACT.CHANGE_PASSWORD_FETCH_SUCCESS
    })
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'User Profile updated successfully',
        level: 'success'
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue changing the user password',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const notificationsSagas = [
  takeLatest(ACT.GET_USER_FETCH_REQUESTED, getUser),
  takeLatest(ACT.SAVE_USER_FETCH_REQUESTED, saveUser),
  takeLatest(ACT.UPDATE_USER_IMAGE_FETCH_REQUESTED, updateUserImage),
  takeLatest(ACT.CHANGE_PASSWORD_FETCH_REQUESTED, changePassword)
]

export default notificationsSagas
